import React, { FC, useContext } from 'react';
import {ActiveDataFilter, DataFilter, DataFilterType} from "../../../models/common/DataFilter";
import { Tooltip, Checkbox, Divider, Typography } from '@mui/material';
import ResponsiveButtonWithTooltip from "../buttons/ResponsiveButtonWithTooltip";
import AddIcon from "@mui/icons-material/Add";
import {buttonStyles} from "../../../config/Theme";
import {DividerDeactivateable, TitleDisplayable} from "../../../models/common/ComponentBehavioural";
import {LanguageContext} from "../../../config/ContextConfig";
import {makeStyles} from "@mui/styles";
import {ReactChildren} from "../../../models/common/ReactChildren";
import BasicSwitch from "../../form/BasicSwitch";
import {TextDisplay} from "../data-display/TextDisplay";

export interface DataFilterInputProps extends TitleDisplayable, DividerDeactivateable, ReactChildren {
    onAddFilterClick: ( activeFilter: DataFilter, isInverted: boolean ) => void
    onInvertedChange: ( activeFilter: DataFilter, isInverted: boolean ) => void
    filter: DataFilter
    isInvertedActive?: boolean
}

export interface DataFilterComponentBaseProps extends Omit<DataFilterInputProps, 'onAddFilterClick' | 'onInvertedChange' | 'filter'> {
    onAddFilterClick: <T>( activeFilter: ActiveDataFilter<T> ) => void
    filterName: string
    filterType?: DataFilterType
}

const useStyles = makeStyles( theme => ({
        ...buttonStyles( theme ),
        root: {
            padding: theme.spacing(),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-evenly'
        },
        title: {
            padding: 5+'px'
        },
        input: {
            width: 50+'%',
            alignItems: 'center'
        },
        inverted: {
            width: 15+'%',
        },
        buttonDiv: {
            width: 30+'%',
            textAlign: 'center'
        }
    })
);

export const DataFilterInput: FC<DataFilterInputProps> = ({ title, filter, onAddFilterClick, children, isInvertedActive, onInvertedChange, noDivider }) => {
    const language = useContext( LanguageContext );
    const classes = useStyles();
    const inverted = isInvertedActive ?? false;
    const hideDivider = noDivider ?? false;

    const onAddHandler = ( _: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        onAddFilterClick( filter, inverted );
    };

    const onInvertedChangeHandler = ( event: React.ChangeEvent< HTMLInputElement > ) => {
        onInvertedChange( filter, event.target.checked );
    };

    return (
        <>
            <div className={classes.title} >
                <TextDisplay variant="body2">{ title }</TextDisplay>
            </div>
            <div className={classes.root}>
                <div className={classes.input}>{ children }</div>
                <div className={classes.inverted}>
                    <Tooltip title={language.common.filterInvert.tooltipText}>
                       <BasicSwitch
                           labelFalse={''}
                           labelTrue={''}
                           label={language.common.filterInvert.buttonText}
                           checked={inverted}
                           name={filter.identifier + '-inverted'}
                           onChange={onInvertedChangeHandler}
                       />
                    </Tooltip>
                </div>
                <div className={classes.buttonDiv}>
                    <ResponsiveButtonWithTooltip
                        variant='xs'
                        text={language.common.add}
                        icon={<AddIcon />}
                        tooltip={''}
                        onClick={onAddHandler}
                        dense
                    />
                </div>
            </div>
            { ! hideDivider ? <Divider /> : null }
       </>
    );
};